  // for facet color name

  /*
  document.querySelectorAll('.facets-colour ul li label').forEach(function(label) {
    label.addEventListener('mouseenter', function() {
        // Find the closest 'li' element and get the text from the .facet-checkbox__text-label
        var li = label.closest('li');
        var facetTextLabel = li.querySelector('.facet-checkbox__text-label');
        
        if (facetTextLabel) {
            var value = facetTextLabel.textContent;
            
            // Find the .facets-color-filter-hover-name element and update its content
            var hoverNameElement = document.querySelector('.facets-color-filter-hover-name');
            if (hoverNameElement) {
                hoverNameElement.textContent = value;
            }
        }
    });
  
    label.addEventListener('mouseleave', function() {
        // Clear the content of the .facets-color-filter-hover-name span when mouse leaves
        var hoverNameElement = document.querySelector('.facets-color-filter-hover-name');
        if (hoverNameElement) {
            hoverNameElement.textContent = ''; // Clear the content
        }
    });
  });
  */

  $('.facets-colour ul li label').hover(
    function() {
      // Find the closest 'li' element and get the text from the .facet-checkbox__text-label
      var value = $(this).closest('li').find('.facet-checkbox__text-label').text();
  
      // Find the .facets-color-filter-hover-name element and update its content
      $('.facets-color-filter-hover-name').text(value);
    },
    function() {
      // Clear the content of the .facets-color-filter-hover-name span when mouse leaves
      $('.facets-color-filter-hover-name').text('');
    }
  );  